const grant_type = "password";
const client_id = "agent_pc";
const client_secret = "3a4b2f854357ba21";

// 账号, 手机号, 选择企业
export const routes = ["LoginAgent", "LoginSwitch", "LoginSite", "LoginApplicationTemplate"];

export const clientType = "housekeeper";

const QybParams = {
  grant_type: "password",
  client_id: "client_pc",
  client_secret: "2cd5b31910183260",
};

const data = {
  grant_type,
  client_id,
  client_secret,
};

// 手机号
export const acLoginAgent = {
  route: routes[0],
  ...data,
};

// 企业号登录
export const acLoginSwitch = {
  route: routes[1],
  ...QybParams,
};

// 体验登录
export const Experience = {
  route: routes[3],
  ...QybParams,
};

export enum AcMode {
  AGENT = 1,
  SWITCH,
}

export const IS_CW = {
  isCw: true,
};

// 财务接口header默认参数
export const financialHeadParams = {
  curmoterid: "00000000-0000-0000-0000-000000000000",
  ismachineaccounts: false,
  psiid: "00000000-0000-0000-0000-000000000000",
  smalltype: 0,
  taxinspectionsurpluscount: 0,
  taxnumber: "",
  ztid: "00000000-0000-0000-0000-000000000000",
};

// 权限name
export enum NAMES {
  APPROVE = "approveCloud",
  BUDGET = "budgetCloud",
  PURCHASE = "InvoicingIndex",
  FINANCIAL = "financialCloud",
  FINANCIAL_LIST = "financialStatements",
  FISCAL_ANALYSIS = "fiscalTaxAnalysis",
  COMPANY = "enterpriseInformation",
}
/** 缩写 */
export const ACRONYMS = [
  [NAMES.APPROVE, "sp"],
  [NAMES.BUDGET, "ys"],
  [NAMES.FINANCIAL, "cw"],
  [NAMES.PURCHASE, "jxc"],
  [NAMES.FINANCIAL_LIST, "cwbb"],
  [NAMES.FISCAL_ANALYSIS, "csfx"],
  [NAMES.COMPANY, "qyxx"],
];

/** 对应权限 */
export const SOCIETY_POWER = [
  [NAMES.APPROVE, "isApprove"],
  [NAMES.BUDGET, "isBudget"],
  [NAMES.FINANCIAL, "isFinancial"],
  [NAMES.PURCHASE, "isPurchase"],
  [NAMES.FINANCIAL_LIST, "isFinancialList"],
  [NAMES.FISCAL_ANALYSIS, "isFiscalAnalysis"],
  [NAMES.COMPANY, "isCompany"],
];
